<template>
<v-container>
  <v-text-field
    id="senha"
    name="senha"
    label="senha"
    v-model="pass"
    required>
  </v-text-field>
  <v-btn flat @click="createPass()">Salvar</v-btn>
</v-container>
</template>

<script>
export default {
  data() {
    return {
      pass: ""
    };
  },
  methods: {
    createPass() {
      String.prototype.hashCode = function() {
        let hash = 0;
        if (this.length == 0) return hash;
        for (let i = 0; i < this.length; i++) {
          let char = this.charCodeAt(i);
          hash = (hash << 5) - hash + char;
          hash = hash & hash; // Convert to 32bit integer
        }
        return Math.abs(hash);
      };
      console.log(this.pass.hashCode());
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/AdminCreateUser.vue